import {redux} from '@app/redux';

export const listDialpadCallcenters = (dispatch, provider) =>
    dispatch(
        redux.rest.actions[
            redux.escalations.constants.LIST_DIALPAD_CALLCENTERS
        ](provider),
    );
